(function () {
  function init(rail) {
    if (rail.dataset.railReady === '1') return;
    rail.dataset.railReady = '1';

    const track = rail.querySelector('[data-rail-track]');
    const next = rail.querySelector('[data-rail-next]');
    const prev = rail.querySelector('[data-rail-prev]');
    if (!track || !next) return;

    const loop = rail.dataset.railLoop === 'true';
    const hasPrev = !!prev;

    const stepSize = () => {
      const slide = track.querySelector('.product-rail__slide');
      if (!slide) return track.clientWidth;
      return slide.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
    };

    const updateNavVisibility = () => {
      const atStart = track.scrollLeft <= 4;
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      if (hasPrev) rail.classList.toggle('has-prev', !atStart);
      rail.classList.toggle('has-next', loop || !atEnd);
    };
    updateNavVisibility();
    track.addEventListener('scroll', updateNavVisibility, { passive: true });
    window.addEventListener('resize', updateNavVisibility);

    next.addEventListener('click', () => {
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      if (atEnd && loop) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (!atEnd) {
        track.scrollBy({ left: stepSize(), behavior: 'smooth' });
      }
    });

    if (prev) {
      prev.addEventListener('click', () => {
        track.scrollBy({ left: -stepSize(), behavior: 'smooth' });
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-rail]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
